import { render, staticRenderFns } from "./commodity-inventory-summary-show.html?vue&type=template&id=3981210b&scoped=true&"
import script from "./commodity-inventory-summary-show.ts?vue&type=script&lang=js&"
export * from "./commodity-inventory-summary-show.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3981210b",
  null
  
)

export default component.exports